import { render, staticRenderFns } from "./ProfessorCourses.vue?vue&type=template&id=034e4e4a&"
import script from "./ProfessorCourses.vue?vue&type=script&lang=js&"
export * from "./ProfessorCourses.vue?vue&type=script&lang=js&"
import style0 from "./ProfessorCourses.vue?vue&type=style&index=0&id=034e4e4a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports